// @core/api/endpoints/license/renew_license.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  LicenseResponse,
  RenewLicenseRequest,
} from '../../../types/license';

const BASE_PATH = '/license';

/**
 * Renew license
 * Extends the validity period of an existing license. Generates a new signed payload with updated expiry. Master-only operation.
 */
export async function RenewLicense(
  license_id: string,
  data: RenewLicenseRequest,
  options?: RequestOptions
): Promise<LicenseResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/licenses/:license_id/renew`;
  requestPath = requestPath.replace(':license_id', encodeURIComponent(license_id));
  const requestOptions = options;
  return client.post<LicenseResponse>(requestPath, data, requestOptions);
}
